import { faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { faMinus, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import { FilterItemRow } from "./FilterItemRowStyle";

export function FilterItem(props) {
    const filterItemClick = (action, item_id) => () => {
        if (item_id !== "data_noresult") {
            props.filterItemClick(action, item_id);
        }
    };
    
    const filterItemDrill = (children) => (e) => {
        e.stopPropagation();
        props.filterItemDrill(children, props.level);
    };
    
    const showAngleIcon = () => {
        if (props.item?.children?.length) {
            return (<div className="angle" onClick={filterItemDrill(props.item)}><FontAwesomeIcon icon={faAngleRight} /></div>);
        }
        return null;
    };
    
    const getDisplay = (typeahead_alias, alias) => {
        if (props.isTypeAhead) {
            if (Array.isArray(typeahead_alias) && typeahead_alias.length) {
                // I could use map but gets messy having to create unique keys
                if (typeahead_alias.length === 2) {
                    return (<><span>{typeahead_alias[0]}</span><span className="more">({typeahead_alias[1]})</span></>);
                }
                return (<span>{typeahead_alias[0]}</span>);
            }
            return (<span>{typeahead_alias}</span>);
        }
        return (<span>{alias}</span>);
    };
    
    const displayCategory = () => {
        if (props.isTypeAhead) {
            return (
                <>
                    <div className="dash">-</div>
                    <div className="item-category">{props.item.pivot_alias}</div>
                </>
            );
        }
        return null;
    };
    const { id, alias, typeahead_alias, selected } = props.item;
    const defaultAction = props.isOmit ? "-" : "+";
    
    const enter = (sign) => (event) => {
        const row = event.currentTarget.closest(".filter-item-row");
        if (row) {
            const css = sign === "minus" ? "hover-minus" : "hover-plus";
            row.classList.add(css);
        }
    };
    
    const exit = (sign) => (event) => {
        const row = event.currentTarget.closest(".filter-item-row");
        if (row) {
            const css = sign === "minus" ? "hover-minus" : "hover-plus";
            row.classList.remove(css);
        }
    };
   
    const getOperators = () => {
        if (id !== "data_noresult") {
            return (
                <>
                    <div onMouseEnter={enter("minus")} onMouseLeave={exit("minus")} onClick={filterItemClick("-", id)}>
                        <FontAwesomeIcon className={classNames("exclude", { selectedExclude: props.previouslySelected && props.operators[0] === "!=" }, { hidden: !props.allowExclude })} icon={faMinus}/>
                    </div>
                    <div onMouseEnter={enter("plus")} onMouseLeave={exit("plus")} onClick={filterItemClick("+", id)}>
                        <FontAwesomeIcon className={classNames("include", { selectedInclude: props.previouslySelected && props.operators[0] === "=" })} icon={faPlus}/>
                    </div>
                </>
            );
        }
        return null;
    };
    return (
        <FilterItemRow
            style={props.style}
            className={classNames(
                "filter-item-row",
                { omitIsDefault: props.isOmit },
                { selectedInclude: props.previouslySelected && props?.operators[0] === "=" },
                { selectedExclude: props.previouslySelected && props?.operators[0] === "!=" },
                { active: props.isHighlightedSuggestion || selected }
            )}
            onClick={(event) => {
                // Prevents the firing of `checkIfClickFromOutsideFilterBar` from FilterBar.js
                // This is needed since adding a filter results in `e.target.closest(".query-builder2")` being null
                event.stopPropagation();
            }}
        >
            {getOperators()}
            <div onClick={filterItemClick(defaultAction, id)} className="row-label">
                <div className="item-value" title={props.isTypeAhead ? "" : alias}>{getDisplay(typeahead_alias, alias)}</div>
                {displayCategory()}
            </div>
            {showAngleIcon()}
        </FilterItemRow>
    );
}
